import { Route } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";
import Login from "../pages/Login";
import Wabys from "../pages/Wabys";
import WaitingList from "../pages/WaitingList";
import DemoDashboard from "../pages/DemoDashboard";
import PdmsPedagogicalTest from "pages/pdms/PdmsPedagogicalTest";
import CheckInOut from "../pages/CheckInOut";
// import Home from "../pages/Home";
// import HomeServicesTraining from "../pages/HomeServicesTraining";
// import HomeEVOTS from "../pages/HomeEVOTS";
// import HomeCareers from "../pages/HomeCareers";
// import HomeAboutUs from "../pages/HomeAboutUs";
// import HomeContactUs from "../pages/HomeContactUs";
// import WatomsTraineesRegistration from "../pages/WatomsTraineesRegistration";
// import WatomsTrainersRegistration from "../pages/watoms/WatomsTrainersRegistration";

export const WabysRoutes = () => [
    <Route key="wabys login temp" path="/" element={<Login />} />,
    <Route key="wabys login" path="/login" element={<Login />} />,
    <Route key="check in" path="/checkin" element={<CheckInOut />} />,
    <Route key="wabys main page" path="/wabys" element={
        <ProtectedRoute>
            <Wabys />
        </ProtectedRoute>
    } />,
    <Route key="qr code waiting list" path="/QRCode/waitingList" element={
        <WaitingList />
    } />,
    <Route key="demo dashboard" path="/demo/dashboard" element={
        <DemoDashboard />
    } />,
    <Route key="pdms pedagogical test" path="/pdms/pedagogical-test" element={<PdmsPedagogicalTest />} />,
    // <Route key="main page" path="/" element={<Home />} />,
    // <Route key="services training" path="/services/training" element={<HomeServicesTraining />} />,
    // <Route key="evots" path="/evots" element={<HomeEVOTS />} />,
    // <Route key="carrers" path="/careers" element={<HomeCareers />} />,
    // <Route key="about us" path="/aboutus" element={<HomeAboutUs />} />,
    // <Route key="contact us" path="/contactus" element={<HomeContactUs />} />,
    // <Route key="vtc trainees registration" path="/vtc-trainees-registration" element={<WatomsTraineesRegistration />} />,
    // <Route key="vtc trainers registration" path="/vtc-trainers-registration" element={<WatomsTrainersRegistration />} />,
];